import { useMutation } from '@tanstack/react-query';
import apiClient from '../services/apiService';

export const useCreateProperty = () => {
  return useMutation({
    mutationFn: async (propertyData) => {
      const formData = new FormData();
      
      formData.append('title', propertyData.title);
      formData.append('description', propertyData.description || '');
      formData.append('address', propertyData.address);
      formData.append('price', String(propertyData.pricePerNight));
      formData.append('type', propertyData.type);
      formData.append('size', String(propertyData.size));
      formData.append('bedrooms', String(propertyData.bedrooms));
      formData.append('bathrooms', String(propertyData.bathrooms));
      formData.append('additional_notes', propertyData.notes);
      
      if (propertyData.images?.length > 0) {
        propertyData.images.forEach((image) => {
          formData.append('images[]', image);
        });
      }
      
      if (propertyData.features?.length > 0) {
        propertyData.features.forEach((feature) => {
          formData.append('features[]', feature);
        });
      }
      
      const response = await apiClient.post('/api/properties', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 120000,
      });
      return response;
    },
  });
};
